/*
**************************************************************************
Title:          Uilities
Created By:     Pankaj Arora
Created on:     05/02/2018
Description:    Read Url paramaters
**************************************************************************
*/

export function GetUrlParameters(): any {
    const paramValues = {};
    try {
        const params = window.location.href.split('?')[1].split('&');

        // split & loop on url parameters
        params.forEach(param => {
            const nameValue = param.split('=');
            paramValues[nameValue[0]] = nameValue[1];
        });
        return paramValues;
    } catch (er) {
        return paramValues;
    }
}
